import {Spin} from 'antd'
import {useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import {Loader} from 'rsuite'
import AuthService from 'src/cms/constants/authService'
import {LayoutSplashScreen} from 'src/cms/layout/core'
import {FallbackView} from 'src/cms/partials'

function SingleSignOn(): JSX.Element {
  const authService = new AuthService()
  const history = useHistory()

  useEffect(() => {
    if (authService.isAuthenticated()) {
      history.push('/dashboard')
    } else {
      authService.signInRedirect()
    }
  }, [])

  return (
    <div>
      <LayoutSplashScreen />
      {/* <Spin size='large' fullscreen /> */}
    </div>
  )
}

export default SingleSignOn
